import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { RequestTableNestedContainer } from './request-table.nested.container';
import { useRequests } from '../../../domains/request/request.service';
import { IRequestTableContainer, OnFilterChangeParams, RequestTableType } from './types';
import { Button } from '../../../_core/button/button.component';
import { RIDialog } from '../../../_core/dialog/dialog.component';
import { EditRequestContainer } from '../../../domains/request/edit/edit-request.container';
import {
  CACHEABLE_ACTIVE_REQUEST_STATUSES,
  CACHEABLE_REQUEST_STATUSES,
  IRequestOverview,
  REQUEST_STATUS
} from '../../../../lib/types';
import { DEFAULT_DRAFT_STATUSES, DEFAULT_REQUEST_STATUSES } from './consts';
import { TableFilterKeys } from '../../../_core/table/table.types';

export const RequestTableContainer: React.FC<IRequestTableContainer> = (props) => {
  const [searchParams] = useSearchParams();
  const initialMode = useMemo(
    () =>
      searchParams.has('mode')
        ? Object.values(RequestTableType).find((v) => v.toLowerCase() === searchParams.get('mode')?.toLowerCase()) ??
          RequestTableType.ACTIVE
        : RequestTableType.ACTIVE,
    [searchParams]
  );

  const [createRequest, setCreateRequest] = useState(false);
  const [includeArchived, setIncludeArchived] = useState(false);
  const [status, setStatus] = useState<REQUEST_STATUS[]>(
    initialMode === RequestTableType.WORKSPACE ? DEFAULT_DRAFT_STATUSES : DEFAULT_REQUEST_STATUSES
  );

  const { requests, loading: requestsLoading } = useRequests({ includeArchived, status });

  const onFilterChange = ({ filters, showingDrafts }: OnFilterChangeParams<IRequestOverview>) => {
    const selectedStatusFilters =
      (filters.find((f) => f.title === TableFilterKeys.STATUS)?.value as REQUEST_STATUS[]) ?? [];

    const selectedCacheableStatusFilters = selectedStatusFilters.filter((s) => CACHEABLE_REQUEST_STATUSES.includes(s));
    if (selectedCacheableStatusFilters.length && selectedCacheableStatusFilters.includes(REQUEST_STATUS.SENT))
      selectedCacheableStatusFilters.push(REQUEST_STATUS.LOCKED);

    const newStatus = selectedCacheableStatusFilters.length
      ? selectedCacheableStatusFilters
      : showingDrafts
      ? [REQUEST_STATUS.DRAFT]
      : CACHEABLE_ACTIVE_REQUEST_STATUSES;

    setIncludeArchived(
      !selectedStatusFilters.length ||
        selectedStatusFilters.some((f) => [REQUEST_STATUS.ARCHIVED_DRAFT, REQUEST_STATUS.ARCHIVED].includes(f))
    );
    setStatus(newStatus);
  };
  return (
    <>
      <RequestTableNestedContainer
        requests={requests}
        requestsLoading={requestsLoading}
        onFilterChange={onFilterChange}
        initialMode={initialMode}
        {...props}
      >
        <Button onClick={() => setCreateRequest(true)} text="Create Request" size="large" className="mt-1" />
      </RequestTableNestedContainer>
      <RIDialog open={createRequest} setOpen={setCreateRequest}>
        <EditRequestContainer />
      </RIDialog>
    </>
  );
};
